//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
// import './style.scss'
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const workSchedule = useStore((state) => state.workSchedule);
  const setWorkSchedule = useStore((state) => state.setWorkSchedule);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.workSchedule.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={workSchedule}
          onChange={(value) => {
            setWorkSchedule(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'work-schedule',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'9 to 5'}>
            <span>🌞</span> {t('onboarding.workSchedule.options.9to5')}
          </Option>
          <Option value={'Night shifts'}>
            <span>🌙</span> {t('onboarding.workSchedule.options.nightShifts')}
          </Option>
          <Option value={'My hours are flexible'}>
            <span>🕐</span> {t('onboarding.workSchedule.options.flexible')}
          </Option>
          <Option value={'Im retired'}>
            <span>👨‍🦳</span> {t('onboarding.workSchedule.options.retired')}
          </Option>
          <Option value={'Im not working'}>
            <span>⛱</span> {t('onboarding.workSchedule.options.notWorking')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
